export type TtqSessionUiState = {
  selectedParticleIds: string[];
  bottomMenuOpen: boolean;
  /** 仅工作台返回时为 true，触发一次恢复 */
  restoreMenu?: boolean;
};

function storageKey(ttqaId: string) {
  return `ttq-ui-${ttqaId}`;
}

export function readTtqSessionUiState(ttqaId: string): TtqSessionUiState | null {
  try {
    const raw = sessionStorage.getItem(storageKey(ttqaId));
    if (!raw) return null;
    const parsed = JSON.parse(raw) as TtqSessionUiState;
    if (!Array.isArray(parsed.selectedParticleIds)) return null;
    return parsed;
  } catch {
    return null;
  }
}

export function writeTtqSessionUiState(ttqaId: string, state: TtqSessionUiState) {
  sessionStorage.setItem(storageKey(ttqaId), JSON.stringify(state));
}

export function clearTtqSessionUiState(ttqaId: string) {
  sessionStorage.removeItem(storageKey(ttqaId));
}

export function consumeTtqMenuRestore(ttqaId: string): TtqSessionUiState | null {
  const saved = readTtqSessionUiState(ttqaId);
  if (!saved?.restoreMenu || saved.selectedParticleIds.length === 0) return null;
  writeTtqSessionUiState(ttqaId, {
    selectedParticleIds: saved.selectedParticleIds,
    bottomMenuOpen: saved.bottomMenuOpen !== false,
    restoreMenu: false,
  });
  return saved;
}

function returnFromKnowledgeKey(ttqaId: string) {
  return `ttq-return-from-knowledge:${ttqaId}`;
}

/** 离开品题画布进入知识颗粒详情前标记，返回时消费以刷新卡片 */
export function markTtqReturnFromKnowledge(ttqaId: string, particleId: string) {
  const id = String(ttqaId || '').trim();
  const pid = String(particleId || '').trim();
  if (!id || !pid) return;
  try {
    sessionStorage.setItem(returnFromKnowledgeKey(id), JSON.stringify({ particleId: pid }));
  } catch {
    // ignore
  }
}

export function consumeTtqReturnFromKnowledge(ttqaId: string): { particleId: string } | null {
  const id = String(ttqaId || '').trim();
  if (!id) return null;
  try {
    const key = returnFromKnowledgeKey(id);
    const raw = sessionStorage.getItem(key);
    if (!raw) return null;
    sessionStorage.removeItem(key);
    const parsed = JSON.parse(raw) as { particleId?: string };
    const particleId = String(parsed?.particleId || '').trim();
    return particleId ? { particleId } : null;
  } catch {
    return null;
  }
}
